import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { AppBar, Toolbar, Button, Box } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';

@inject('commonStore')
@observer
class Bottom extends Component {
  handleClickConfirm = () => {
    const { commonStore, history, location } = this.props;
    history.push(`/${commonStore.companyId}/${commonStore.storeCode}${location.search}`);
  };

  render() {
    const { t } = this.props;
    return (
      <AppBar position="fixed" color="primary" className="bottom">
        <Toolbar>
          <Button fullWidth onClick={this.handleClickConfirm} className="bottom-button">
            <Box className="bottom-button-title">{t('order.button.order')}</Box>
          </Button>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withRouter(withTranslation()(Bottom));
